import styled from 'styled-components'
import {StyledDiv} from './StyledTypeDefinitions'

const PreformattedDiv: StyledDiv = styled.div`
   white-space: pre-wrap;
`

export default PreformattedDiv
